import { create } from 'zustand';

export type LogLevel = 'error' | 'warn' | 'info' | 'log';

export interface ConsoleEntry {
  id: string;
  level: LogLevel;
  message: string;
  details?: any[];
  stack?: string;
  timestamp: Date;
  count: number;
  source?: string;
}

interface ConsoleDebugStore {
  entries: ConsoleEntry[];
  maxEntries: number;
  isEnabled: boolean;
  addEntry: (entry: Omit<ConsoleEntry, 'id' | 'timestamp' | 'count'>) => void;
  clearEntries: () => void;
  setEnabled: (enabled: boolean) => void;
  exportEntries: () => string;
}

export const useConsoleDebugStore = create<ConsoleDebugStore>((set, get) => ({
  entries: [],
  maxEntries: 200,
  isEnabled: true,
  
  addEntry: (entry) => {
    set((state) => {
      const existingIndex = state.entries.findIndex(
        e => e.message === entry.message && e.level === entry.level && e.stack === entry.stack
      );
      
      if (existingIndex !== -1) {
        // Increment count for duplicate entries
        const updatedEntries = [...state.entries];
        updatedEntries[existingIndex] = {
          ...updatedEntries[existingIndex],
          count: updatedEntries[existingIndex].count + 1,
          timestamp: new Date(),
        };
        return { entries: updatedEntries };
      } else {
        // Add new entry
        const id = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        const newEntry: ConsoleEntry = {
          ...entry,
          id,
          timestamp: new Date(),
          count: 1,
        };
        
        return {
          entries: [newEntry, ...state.entries].slice(0, state.maxEntries),
        };
      }
    });
  },
  
  clearEntries: () => {
    set({ entries: [] });
  },
  
  setEnabled: (enabled) => {
    set({ isEnabled: enabled });
  },
  
  exportEntries: () => {
    const { entries } = get();
    return JSON.stringify(entries, null, 2);
  },
}));